<template>
  <div class="travelLine" id="travelLine">
    <div class="container">
      <div class="title-top">
        <div class="title">
          <div class="one">{{message.styleTitle}}</div>
          <div class="describe">{{message.styleDescribe}}</div>
        </div>
        <div class="button-right" @click="toMore">
          <span>
            更多
            <i class="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="list">
        <div
          class="content"
          v-for="(item,index) in message.linePageList[0].linePage"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="rotation-left">
            <div class="trans-img">
              <img :src="item.linePictureUrl" class="left-img" />
            </div>
            <div class="basic-information">
              <div class="info-bottom">
                <div>
                  <span class="label">{{ item.price ? `￥${item.price}` : '价格待定' }}</span>
                </div>
                <div>
                  <span>
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{fomateDate(item.date)}}
                  </span>
                  <span class="weeek" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="rotation-right">
            <div class="ones">{{item.lineTitile}}</div>
            <div class="two">{{item.lineAbstract}}</div>
            <!-- <span class="more" @click="toMore">
              查看更多
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- aboutUs end -->
</template>

<script>
import axios from "axios";
import { fomateDate } from "@/util/util";

export default {
  name: "travelLine",
  data() {
    return {};
  },
  props: {
    message: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  computed: {
    nav() {
      return this.$route.params.id;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  mounted() {},
  methods: {
    fomateDate,
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id: id }
      });
    },
    // toMore(){
    //   this.$router.push({ path: `activityIndex/0` });
    // },
    toMore() {
      this.$router.push({
        path: `/searchActivity`,
        query: {
          id: this.message.styleId,
          title: this.message.styleTitle
        }
      });
    }
    //基本信息
  }
};
</script>

<style scoped>
.travelLine {
  width: 100%;
  background: #f5f5f5;
}
.container {
  position: relative;

  text-align: left;
}
.title-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 小标题 */
.title {
  margin: 20px 0;
}
.one {
  color: #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
}
.describe {
  border-top: 1px solid #cccccc;
  padding: 10px 0;
  color: #676767;
  font-size: 14px;
  width: 300px;
}
.button-right {
  cursor: pointer;
  width: 80px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.content {
  display: flex;
  width: 48%;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  box-shadow: 0px 0px 10px #aaaaaa;
}
.rotation-left {
  position: relative;
  width: 65%;
  height: 260px;
  cursor: pointer;
}
.content:hover .left-img {
    transform: scale(1.2);

}
.rotation-right {
  position: relative;
  width: 35%;
  height: 260px;
  background: #fff;
  padding: 8px 12px 0 12px;
  box-sizing: border-box;
}
.trans-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.left-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .left-img:hover {
  transform: scale(1.2);
} */
.basic-information {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  color: #fff;
  padding: 10px 20px;
}
.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.6);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #ffffff;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.weeek {
  display: inline-block;
  margin-left: 20px;
  background: #f07621;
  color: #fff;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 12px;
  cursor: pointer;
}

.ones {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px;
  line-height: 24px;
}
.two {
  color: #7f7f7f;
  font-size: 14px;
  line-height: 20px;
}
.more {
  width: 100%;
  position: absolute;
  text-align: center;
  bottom: 10px;
  color: #007642;
  cursor: pointer;
}
.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/home/travelLine.vue